import type {TIconProps} from './Button.type';
import {
  ArrowRightDoteIcon,
  ArrowRightIcon,
  DiagramIcon,
  DownloadIcon,
  EyeIcon,
  LikeIcon,
  LinkIcon,
  PlayIcon,
  QuizIcon,
  ShareIcon,
  SmGrowthIcon,
} from './icons';

export const renderIcon = (icon: TIconProps) => {
  if (typeof icon === 'string') {
    switch (icon) {
      case 'link':
        return <LinkIcon />;
      case 'play':
        return <PlayIcon />;
      case 'eye':
        return <EyeIcon />;
      case 'like':
        return <LikeIcon />;
      case 'arrowRight':
        return <ArrowRightIcon />;
      case 'arrowRightDote':
        return <ArrowRightDoteIcon />;
      case 'download':
        return <DownloadIcon />;
      case 'quiz':
        return <QuizIcon />;
      case 'diagram':
        return <DiagramIcon />;
      case 'sm_growth':
        return <SmGrowthIcon />;
      case 'share':
        return <ShareIcon />;
    }
  } else {
    return icon;
  }
};
